import Vue from "vue";
import VueI18n from '../i18n.js' 

export default {
  async doLogin({ commit }, payload) {
    let user = await Vue.axios.post(Vue.$url("login/doLogin"), payload);
    Vue.$log.debug("login response", JSON.stringify(user.data, null, 2));
    commit("mLogin", user.data);
  },
  async doCheckUserAlreadyLogged({ commit }) {
    let user = await Vue.axios.get(Vue.$url("login/check"), { withCredentials: true });
    commit("mLogin", user.data);
  },
  doLogout({ commit }) {
    commit("mLogout");
  },
  async doLoadLanguageList({ commit }) {
    let languages = await Vue.axios.get(Vue.$url("language"));
    commit("mLanguage", languages.data);
  },
  async doUpdateUserLanguage({ commit }, payload) {
    await Vue.axios.put(Vue.$url("user/" + payload.userid + "/language/" + payload.lang));
    commit("mUserLanguage", payload.lang);
  },
  async doLoadAzureMapKey({ commit }) {
    let res = await Vue.axios.get(Vue.$url("user/mapskey"));
    commit("mAzureMapKey", res.data);
  },

  async doLoadDevices({ commit }) {
    let res = await Vue.axios.get(Vue.$url(`device`));
    commit("mDevices", res.data);
  },
  async doLoadKpi({ commit }) {
    let res = await Vue.axios.get(Vue.$url(`kpi`));
    commit("mKpi", res.data);
  },
  async doGetDevice({ commit }, payload) {
    let res = await Vue.axios.get(Vue.$url(`device/${payload}`));
    let device = res.data;
    device.deviceId = payload;
    commit("mCurrentDevice", device);
  },
  async doSetSAE({ commit }, payload) {
    let res = await Vue.axios.post(Vue.$url(`device/${payload.id}/sae`), payload.data);
    if (res.data.success) {
      commit("mShowInfoMessage", VueI18n.t('device.command.confirm'))
    }
    return res.data
  },
  async doLoadHistoricalData({ commit }, payload) {
    let res = await Vue.axios.get(Vue.$url(`device/${payload.device}/${payload.kpi}/${payload.date}`));
    let values = {
      kpi: payload.kpi,
      data: res.data,
    };
    commit("mCurrentDeviceHistoricalData", values);
  },
  async doLoadAlarmData({ commit }, payload) {
    Vue.$log.info(payload)
    let res = await Vue.axios.get(Vue.$url(`device/${payload.device}/alarms?page=${payload.page}&pageSize=${payload.pageSize}`));
    commit("mCurrentDeviceAlarmData", res.data);
  },
  async doGetAlarmsState({ commit }, payload) {
    let res = await Vue.axios.get(Vue.$url(`device/${payload}/alarms/state`));
    commit("mCurrentDevicePir", res.data.dvralarms);
  },
  async doSetAlarmsState({ commit }, payload) {
    let res = await Vue.axios.put(Vue.$url(`device/${payload.device}/alarms/state`), payload.data);
    commit("mCurrentDevicePir", res.data.dvralarms);
  },
  async doTakeSnapshot(_, payload) {
    let res = await Vue.axios.post(Vue.$url(`device/${payload.device}/snapshot`), payload);
    return res.data
  },
  async doAlarmOnDemand(_, payload) {
    await Vue.axios.post(Vue.$url(`device/${payload}/gpio`));
  },
  async doPingDevice(_, payload) {
    await Vue.axios.get(Vue.$url(`device/${payload}/ping`));
  },

  async doLoadTranslations({ commit }) {
    let res = await Vue.axios.get(Vue.$url(`translation`));
    commit("mAdminTranslations", res.data);
  },
  async doCreateTranslation({ commit }, payload) {
    let res = await Vue.axios.post(Vue.$url(`translation/${payload.key}/${payload.lang}`), payload);
    commit("mAdminTranslations", res.data);
  },
  async doUpdateTranslation({ commit }, payload) {
    let res = await Vue.axios.put(Vue.$url(`translation/${payload.key}/${payload.lang}`), payload);
    commit("mAdminTranslations", res.data);
  },
  async doDeleteTranslation({ commit }, payload) {
    let res = await Vue.axios.delete(Vue.$url(`translation/${payload.key}/${payload.lang}`));
    commit("mAdminTranslations", res.data);
  },

  async doAdminLoadUsers({ commit }) {
    let res = await Vue.axios.get(Vue.$url("admin/users"));
    commit("mAdminUsers", res.data);
  },
  async doAdminCreateUser({ commit }, payload) {
    let res = await Vue.axios.post(Vue.$url("admin/user"), payload);
    commit("mAdminUsers", res.data);
  },
  async doAdminUpdateUser({ commit }, payload) {
    let res = await Vue.axios.put(Vue.$url(`admin/user/${payload.id}`), payload);
    commit("mAdminUsers", res.data);
  },
  async doAdminDeleteUser({ commit }, payload) {
    let res = await Vue.axios.delete(Vue.$url(`admin/user/${payload.id}`));
    commit("mAdminUsers", res.data);
  },

  async doAdminLoadContacts({ commit }) {
    let res = await Vue.axios.get(Vue.$url("admin/contacts"));
    commit("mAdminContacts", res.data);
  },
  async doAdminCreateContact({ commit }, payload) {
    let res = await Vue.axios.post(Vue.$url("admin/contact"), payload);
    commit("mAdminContacts", res.data);
  },
  async doAdminUpdateContact({ commit }, payload) {
    let res = await Vue.axios.put(Vue.$url(`admin/contact/${payload.id}`), payload);
    commit("mAdminContacts", res.data);
  },
  async doAdminDeleteContact({ commit }, payload) {
    let res = await Vue.axios.delete(Vue.$url(`admin/contact/${payload.id}`));
    commit("mAdminContacts", res.data);
  },
};
